import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "prod-offer" };
var _hoisted_2 = { class: "prod-offer__wrap" };
var _hoisted_3 = { class: "prod-offer__block" };
var _hoisted_4 = {
    key: 0,
    class: "prod-offer__block"
};
var _hoisted_5 = { class: "prod-offer__block" };
import FilterSelector from "./FilterSelector.vue";
import { computed, inject, ref, watch } from "vue";
import OfferPrice from "./OfferPrice.vue";
import PreOrder from "./PreOrder.vue";
import HintTooltip from "./HintTooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferSelector',
    props: {
        product: { type: Object, required: true },
        types: { type: Array, required: true },
        hintTeleport: Object,
    },
    setup: function (__props) {
        var props = __props;
        var activeType = inject('type', ref(props.types[0]));
        var activeOffer = ref();
        var offerModel = inject('offer', ref(null));
        var isGiftSet = computed(function () { var _a; return ((_a = activeType.value) === null || _a === void 0 ? void 0 : _a.name) === 'Набор'; });
        var offersByType = computed(function () { return props.product.offers.filter(function (offer) { var _a; return offer.type === ((_a = activeType.value) === null || _a === void 0 ? void 0 : _a.id); }); });
        var filters = computed(function () {
            return offersByType.value.map(function (offer) {
                var _a;
                return ({
                    id: offer.id,
                    name: offer.volume ? "".concat(offer.volume, " \u043C\u043B") : offer.name,
                    volume: offer.volume,
                    flag: ((_a = offer.distinction) === null || _a === void 0 ? void 0 : _a.join(', ')) || '',
                    disabled: !offer.active,
                });
            });
        });
        function selectDefaultOffer(items) {
            var _a, _b;
            if (!items.length) {
                activeOffer.value = undefined;
                return;
            }
            activeOffer.value = (_b = (_a = items.find(function (item) { var _a; return item.id === ((_a = activeOffer.value) === null || _a === void 0 ? void 0 : _a.id); })) !== null && _a !== void 0 ? _a : items.find(function (item) { return item.volume && parseInt(item.volume) >= 15; })) !== null && _b !== void 0 ? _b : items[0];
        }
        // Пересчитываем и сразу синхронно ставим оффер при смене типа, чтобы избежать вспышки обложки
        watch(activeType, function () {
            selectDefaultOffer(filters.value);
        }, { immediate: true });
        if (offerModel.value) {
            var initialType = props.types.find(function (t) { var _a; return t.id === ((_a = offerModel.value) === null || _a === void 0 ? void 0 : _a.type); });
            if (initialType) {
                activeType.value = initialType;
            }
            if (offersByType.value.find(function (o) { var _a; return o.id === ((_a = offerModel.value) === null || _a === void 0 ? void 0 : _a.id); })) {
                activeOffer.value = filters.value.find(function (f) { var _a; return f.id === ((_a = offerModel.value) === null || _a === void 0 ? void 0 : _a.id); });
            }
        }
        var filtersTitle = computed(function () { return isGiftSet.value ? 'Набор' : 'Объём'; });
        var offer = computed(function () {
            return offersByType.value.find(function (o) { var _a; return o.id === ((_a = activeOffer.value) === null || _a === void 0 ? void 0 : _a.id); });
        });
        var hintButtonMessage = computed(function () {
            if (!offer.value) {
                return '';
            }
            var flags = [];
            if (offer.value.tester) {
                flags.push('тестер');
            }
            if (offer.value.sample) {
                flags.push('сэмпл');
            }
            if (offer.value.refill) {
                flags.push('refill');
            }
            return flags.length ? "\u0427\u0442\u043E \u0442\u0430\u043A\u043E\u0435 ".concat(flags.join('/'), "?") : '';
        });
        watch(offer, function (value) {
            offerModel.value = value || null;
        });
        if (offer.value) {
            offerModel.value = offer.value;
        }
        return function (_ctx, _cache) {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(FilterSelector, {
                            title: "Тип",
                            name: "product_type",
                            items: __props.types,
                            modelValue: _unref(activeType),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(activeType) ? (activeType).value = $event : null); })
                        }, null, 8 /* PROPS */, ["items", "modelValue"])
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (!((_a = _unref(activeType)) === null || _a === void 0 ? void 0 : _a.disabled))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(FilterSelector, {
                                title: filtersTitle.value,
                                name: "product_filter",
                                items: filters.value,
                                modelValue: activeOffer.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((activeOffer).value = $event); })
                            }, null, 8 /* PROPS */, ["title", "items", "modelValue"]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            (offer.value && (offer.value.tester || offer.value.refill || offer.value.sample))
                                ? (_openBlock(), _createBlock(HintTooltip, {
                                    key: 0,
                                    message: hintButtonMessage.value,
                                    "class-prefix": "prod-options__help",
                                    refill: offer.value.refill,
                                    tester: offer.value.tester,
                                    sample: offer.value.sample,
                                    teleport: __props.hintTeleport
                                }, null, 8 /* PROPS */, ["message", "refill", "tester", "sample", "teleport"]))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        ((_b = offer.value) === null || _b === void 0 ? void 0 : _b.id)
                            ? (_openBlock(), _createBlock(OfferPrice, {
                                key: 0,
                                offer: offer.value
                            }, null, 8 /* PROPS */, ["offer"]))
                            : ((_c = _unref(activeType)) === null || _c === void 0 ? void 0 : _c.disabled)
                                ? (_openBlock(), _createBlock(PreOrder, {
                                    key: 1,
                                    "product-id": __props.product.id,
                                    type: _unref(activeType)
                                }, null, 8 /* PROPS */, ["product-id", "type"]))
                                : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
